const {h, render, Component} = require('preact');
const EmailView = require('../../views/contact_us/email')
const CallbackView = require('../../views/contact_us/callback')
const ChatView = require('../../views/contact_us/chat')
const LiveChatView = require('../../views/contact_us/boldchat/live_chat')
const queryString = require('qs')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const SpinnerView = require('../../views/common/spinner')
const LiveChatAvailable = require('../../views/contact_us/boldchat/live_chat_available')
const ErrorView = require('../main/error')

class ContactChannels extends Component {
  constructor(props) {
    super(props);
    this.getContactChannelViews = this.getContactChannelViews.bind(this);
    this.startLiveChatAvailable = this.startLiveChatAvailable.bind(this);
    this.constructQueryParams = this.constructQueryParams.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
    this.state = {
      contactChannels: null,
      isContactChannelsLoading: false
    }
  }

  constructQueryParams() {
    let contactChannelParams = this.props.contactChannelParams
    let queryParams = {
      dropdown_category: encodeURI(contactChannelParams.dropdownCategory),
      dropdown_subcategory: encodeURI(contactChannelParams.dropdownSubcategory),
      dropdown_title: encodeURI(contactChannelParams.title)
    }
    if (contactChannelParams.primaryCategoryId) {
      queryParams = Object.assign(queryParams, {
        category_id: contactChannelParams.primaryCategoryId,
        title: contactChannelParams.title,
        article_id: contactChannelParams.contentId
      })
    }
    let selectedItem = contactChannelParams.selectedItem
    if (selectedItem) {
      queryParams.order_id = selectedItem.order_id
      queryParams.claim_id = selectedItem.claim_id
      if (selectedItem.dealId) {
        queryParams.deal_id = selectedItem.dealId
      }
      if (selectedItem.transaction_id) {
        queryParams.transaction_id = selectedItem.transaction_id
      }
    }
    return queryParams
  }

  componentWillMount() {
    let queryParams = this.constructQueryParams()
    this.setState({'issueParams': queryParams})
    let qs = queryString.stringify(this.state.issueParams)
    let contactChannelUrl = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/contact_channels`;
    contactChannelUrl = contactChannelUrl + "?" + qs
    let errorCb = (response) => {
      this.setState({'contactChannels': null, 'isContactChannelsLoading': false, 'isFailure': true})
    }
    let successCb = (response) => {
      if(response)
      {
        this.setState({'contactChannels': response, 'isContactChannelsLoading': false})
      }
    }
    this.setState({'isContactChannelsLoading': true})
    SupportAPIHelper.get(contactChannelUrl, null, successCb, errorCb, false);
  }

  startLiveChatAvailable() {
    setTimeout(() => {
      this.setState({ startLiveChatAvailable: true })
    }, 1000) // delay
  }

  getChannelsAsIcon(){
    if (this.state.contactChannels.contactChannels){
      return (
        <div>
          {this.state.contactChannels.contactChannels.chat &&
            <ChatView
              params = {this.state.contactChannels}
            />
          }
          {this.state.contactChannels.contactChannels.email &&
            <EmailView
              params = {this.state.contactChannels}
              contactChannelParams = {this.props.contactChannelParams}
            />
          }
          {this.state.contactChannels.contactChannels.phone &&
            <CallbackView
              params = {this.state.contactChannels}
              contactChannelParams = {this.props.contactChannelParams}
            />
          }
        </div>
      );
    }
  }

  getChannelAsIconAndText() {
    if (this.state.contactChannels.contactChannels){
      return (
        <div>
          {this.state.contactChannels.contactChannels.chat &&
          <ChatView
            params = {this.state.contactChannels}
          />
          }
          {this.state.contactChannels.contactChannels.email &&
          <EmailView
            params = {this.state.contactChannels}
            contactChannelParams = {this.props.contactChannelParams}
            guestOrder = {this.props.guestOrder}
          />
          }
          <br></br>
          {this.state.contactChannels.contactChannels.phone &&
          <div class="channels-as-text">
            <CallbackView
              params = {this.state.contactChannels}
              contactChannelParams = {this.props.contactChannelParams}
              guestOrder = {this.props.guestOrder}
            />
          </div>
          }
        </div>
      );
    }
  }

  getChannelsAsText(){
    return (
      <div>
        {this.state.contactChannels.contactChannels.chat &&
          <ChatView
            params = {this.state.contactChannels}
          />
        }
        <br/>
        {(this.state.contactChannels.contactChannels.email || this.state.contactChannels.contactChannels.phone) &&
          <div class="channels-as-text">
            {I18n.translate("js.modules.support.you_can_also")}&nbsp;
            {this.state.contactChannels.contactChannels.email &&
              <EmailView
                params = {this.state.contactChannels}
                contactChannelParams = {this.props.contactChannelParams}
                guestOrder = {this.props.guestOrder}
              />
            }
            &nbsp;
            {this.state.contactChannels.contactChannels.phone &&
              <CallbackView
                params = {this.state.contactChannels}
                contactChannelParams = {this.props.contactChannelParams}
                guestOrder = {this.props.guestOrder}
              />
            }
          </div>
        }
      </div>
    );
  }

  getContactChannelViews(){
    let contactChannels = this.state.contactChannels
    if (this.state.isFailure)
      return (<ErrorView />)
    else if(!this.state.isContactChannelsLoading){
      return (
      <div>
        {(this.configFromDom.showNewChannelLayoutInWeb2018 && !contactChannels.shouldShowEmailButtonLayout)? this.getChannelsAsText() : (this.getChannelAsIconAndText())}
        <LiveChatView
          params={contactChannels}
          onComponentDidMount={this.startLiveChatAvailable}
          guestOrder = {this.props.guestOrder}
        />
        {this.state.startLiveChatAvailable && <LiveChatAvailable/>}
      </div>
      )
    }

    return <SpinnerView/>
  }

  render() {
    if(this.state.issueParams)
    {
      return (
        <div>
          <div class='issue-chosen'>{this.state.issueParams.title}</div>
          <div class='choose-your-preference'>{I18n.translate("js.modules.web_2018.choose_preferred_contact_method")}</div>
          <div class="all-channels">
            {this.getContactChannelViews()}
            <div id="thank-you-container-indicator"/>
          </div>
        </div>
      )
    }
  }
}

module.exports = ContactChannels
